module.exports = __webpack_public_path__ + "media/images/ui__arrowDownInactive-3eb093219c6c2427035ec8eb60373346.png";